import { App } from 'vue';
import useProviders from './composables/useProviders';

export const registerProviders = (app: App): void => {
    const { provideEcho, provideGeographyRepository } = useProviders();

    provideGeographyRepository(app);
    provideEcho(app);
};
